import styled, { css } from 'styled-components';
import constants from '../../common/theme/constants';

const { baseFontSize, fontSize, fontWeight, spacing } = constants;

export const CardListItem = styled.li`
  list-style: none;
`;

export const CardWrapper = styled.div<{
  noHover?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}>`
  position: relative;
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-weight: ${fontWeight.normal};
  font-size: ${baseFontSize}px;
  background-color: ${({ theme }) => theme.card.body.bg};
  color: ${({ theme }) => theme.page.body.text};
  box-shadow: 0 2px 6px 0 ${({ theme }) => theme.shadow.default};
  cursor: ${({ onClick, disabled }) => (onClick && !disabled ? 'pointer' : 'auto')};
  height: 100%;

  ${({ onClick, noHover, disabled }) =>
    !noHover &&
    onClick &&
    !disabled &&
    css`
      &:hover {
        box-shadow: 0 2px 6px 0 ${({ theme }) => theme.shadow.hover};
      }
    `}

  &:focus {
    outline-offset: 2px;
    outline: 2px solid ${({ theme }) => theme.focus};
  }
`;

export const CardHeader = styled.div`
  padding: ${spacing.absolute.s}px ${spacing.absolute.m}px;
  border-bottom: 1px solid ${({ theme }) => theme.card.header.border};
  background-color: ${({ theme }) => theme.card.header.bg};
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;

  & h3 {
    font-family: ${({ theme }) => theme.headingFont?.fontFamily || theme.font.fontFamily};
    color: ${({ theme }) => theme.card.header.text};
    font-size: ${({ theme }) => theme.headingFont.fontSize.h5}rem;
    font-weight: ${fontWeight.bold};
    margin: 0;
  }
`;

export const CardBody = styled.div`
  background-color: ${({ theme }) => theme.card.body.bg};
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-size: ${fontSize.p}rem;
  font-weight: ${fontWeight.normal};
  color: ${({ theme }) => theme.card.body.text};
  padding: ${spacing.absolute.m}px;
`;

export const CardTitle = styled.h3`
  font-size: ${({ theme }) => theme.headingFont.fontSize.h5}rem;
  overflow-x: hidden;
  text-overflow: ellipsis;
`;

export const CardSubtitle = styled.p`
  font-size: ${fontSize.p}rem;
  font-weight: ${fontWeight.normal};
  overflow-x: hidden;
  text-overflow: ellipsis;
`;
